module.exports = __webpack_public_path__ + "12b40eddc1307eacaccb7bfd64191239.png";